import Carousel from "../components/Carousel";
import ProgramsCarousel from "../components/ProgramsCarousel";
import NewsAndPublications from "../components/NewsAndPublications";
import Funders from "../components/Funders";

const Home = () => {
  return (
    <div>
      <Carousel />
      <ProgramsCarousel />
      <NewsAndPublications />
      <Funders />
      {/* You can add more homepage sections here */}
    </div>
  );
};

export default Home;
